import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import 'src/shared_modules/veu-visitors-core/components/popovers/popovers.css';


class PopoverReminderStream extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    clickClose() {
        this.props.hidePopover("ReminderStream");
    }

    render() {
        let link = "/"+ this.props.event.path + "/stream";

                return (<div className="popover reminderStream">
                            <h1><Translate>popovers.reminder.stream.message</Translate></h1>
                            <Link to={link}><Translate>popovers.reminder.stream.linktext</Translate></Link>
                    </div>);
    }
}

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */

const mapStateToProps = ( state, ownProps ) => {
    return {
        system : state.system,
        event : state.event,
    };
};

const mapDispatchToProps = {
    showPopover,
    hidePopover,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PopoverReminderStream);
